import { useEffect, useReducer, useState } from "react";
import {
  Box,
  Card,
  CardHeader,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import PageLoading from "../../../../components/Loading/PageLoading";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import BASEURL from "../../../../pages/Utils/Baseurl";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  allsalesorders,
  generateSalesorderPdf,
  todaySalesOrderFilterState,
  TodaySalesOrderFilterStateMange,
  updateSalesOrder,
  exportPastDateSalesOrder,
  exportTodaySalesOrder,
  pastDateSales,
  todaySalesOrder,
  pastSalesOrders,
  pastPendingSalesOrders,
  pastApprovedSalesOrders
} from "../salesOrderData/salesOrderData";
import { downloadExcelFile } from "../../../function/downloadExcel";
import request from "graphql-request";
import RoleAccess from "../../../function/RoleAccess";
import { MdChangeCircle } from "react-icons/md";
import { useLoading } from "../../../../context/LodingContext";
import { PiFilePdfFill } from "react-icons/pi";
import PDFURL from "../../../../pages/Utils/pdfurl";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import RefreshIcon from "@mui/icons-material/Refresh";
import TableComponents from "../../../../components/tabel/index"

const SalesOrderList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [todaySalesOrderData, dispatch] = useReducer(
    TodaySalesOrderFilterStateMange,
    todaySalesOrderFilterState,
  );
  const [fromDateError, setFromDateError] = useState(null);
  const [toDateError, setToDateError] = useState(null);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const salesOrderListTable = {
    columns: [
      {
        header: "S.No",
        accessorKey: "sno",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Sales Order Id",
        accessorKey: "sio",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Customer Name",
        accessorKey: "customerName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Order Type",
        accessorKey: "orderType",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Order Date",
        accessorKey: "orderDate",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Total Amount",
        accessorKey: "totalAmount",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Created By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Created On",
        accessorKey: "createdOn",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      sio: v.soNumber,
      customerName: v.customer?.customerName,
      orderType: v?.orderType,
      orderDate: v?.orderDate,
      totalAmount: v?.totalAmount,
      createdBy: v?.user?.employeeName,
      createdOn: v?.createdAt?.slice(0, 10),
      status: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color:
                v?.status?.toLowerCase() === "pending"
                  ? "orange"
                  : v?.status?.toLowerCase() === "approved"
                    ? "#4caf50"
                    : "red",
            }}
          >
            {_.capitalize(v?.status)}
          </Typography>
          {v?.status?.toLowerCase() == "pending" && (
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleChangeStatus(v?.id)}
            />
          )}
        </Box>
      ),

      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "5px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Sales Order Screen" component="ViewSalesOrder">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/sales-order/view-sales-order`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>

          {/* <RoleAccess
            modelName="Sales Order Screen"
            component="UpdateSalesOrder"
          >
            {v?.status?.toLowerCase() == "pending" && (
              <RoleAccess
                modelName="Sales Order Screen"
                component="UpdateSalesOrder"
              >
                <EditIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() =>
                    navigate(`/sales-order/edit-sales-order`, {
                      state: { type: "edit", data: v },
                    })
                  }
                />
              </RoleAccess>
            )}
          </RoleAccess> */}

          <RoleAccess modelName="Sales Order Screen" component="PdfSalesOrder">
            <PiFilePdfFill
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDownloadPdf(v)}
            />
          </RoleAccess>

          {/* 
            <DeleteIcon
              style={{ color: "GrayText", fontSize: "20px" }}
              onClick={() => handleDelte(v?.id)}
            /> */}
        </div>
      ),
    })),
  };

  const resetFilters = () => {
    dispatch({ name: "reset" });
    setFromDateError(null);
    setToDateError(null);
  };

  const handleDownload = () => {
    // setCirleLoading(true);
    // if (
    //   todaySalesOrderFilterState?.fromDate &&
    //   todaySalesOrderFilterState?.toDate &&
    //   value === 1
    // ) {
    //   const startDate = todaySalesOrderFilterState?.fromDate;
    //   const endDate = todaySalesOrderFilterState?.toDate;
    //   request(BASEURL, exportPastDateSalesOrder, { startDate, endDate }).then(
    //     async (res) => {
    //       const status = res?.exportPastProduct?.success;
    //       const pdfurl = `${URL}${res?.exportPastProduct?.fileUrl?.slice(1)}`;
    //       if (status) {
    //         const status = await downloadExcelFile(
    //           pdfurl,
    //           "filter_sales_order.xlsx",
    //         );
    //         setCirleLoading(false);
    //       }
    //     },
    //   );
    // } else {
    //   request(BASEURL, exportTodaySalesOrder).then(async (res) => {
    //     const status = res?.exportTodayProduct?.success;
    //     const message = res?.exportTodayProduct?.message;
    //     const pdfurl = `${URL}${res?.exportTodayProduct?.fileUrl?.slice(1)}`;
    //     if (status) {
    //       const status = await downloadExcelFile(pdfurl, "Today_Product.xlsx");
    //       setCirleLoading(false);
    //     } else {
    //       setCirleLoading(false);
    //       Swal.fire({
    //         position: "top",
    //         icon: "error",
    //         title: message,
    //         showConfirmButton: true,
    //       });
    //     }
    //   });
    // }
  };
  const handleChange = (event, newValue) => {
    setData([]);
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setValue(newValue);
    resetFilters();
  };

  const fetchPastPendingSalesOrder = async () => {
    setIsLoading(true);
    try {
      const variables = {
        ...(todaySalesOrderData?.fromDate && {
          startDate: todaySalesOrderData.fromDate,
        }),
        ...(todaySalesOrderData?.toDate && {
          endDate: todaySalesOrderData.toDate,
        }),
        ...{
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        }
      };
      const res = await request(BASEURL, pastPendingSalesOrders, variables);

      if (res?.pendingSalesOrders?.success) {
        setData(res?.pendingSalesOrders?.data);
        setDataCount({
          pageCount: res?.pendingSalesOrders?.totalPages,
          itemCount: res?.pendingSalesOrders?.totalCount
        })
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPastApprovedSalesOrder = async () => {
    setIsLoading(true);
    try {
      const variables = {
        ...(todaySalesOrderData?.fromDate && {
          startDate: todaySalesOrderData.fromDate,
        }),
        ...(todaySalesOrderData?.toDate && {
          endDate: todaySalesOrderData.toDate,
        }),
        ...{
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        }
      };
      const res = await request(BASEURL, pastApprovedSalesOrders, variables);

      if (res?.approvedSalesOrders?.success) {
        setData(res?.approvedSalesOrders?.data);
        setDataCount({
          pageCount: res?.approvedSalesOrders?.totalPages,
          itemCount: res?.approvedSalesOrders?.totalCount
        })
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {

    if (value === 0) {
      fetchtodaySalesOrder();
    } else if (value === 1) {
      if (fromDateError || toDateError) return;
      fetchPastPendingSalesOrder();
    } else {
      fetchPastApprovedSalesOrder();
    }
  }, [value, pagination, todaySalesOrderData]);

  useEffect(() => {
    const validateDates = (fromDate, toDate) => {
      const today = new Date();
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);

      const errors = {
        fromDateError: null,
        toDateError: null,
      };

      if (fromDateObj > today) {
        errors.fromDateError = "From Date cannot be greater than today's date.";
      }

      if (toDateObj > today) {
        errors.toDateError = "To Date cannot be greater than today's date.";
      }

      if (toDateObj < fromDateObj) {
        errors.toDateError = "To Date cannot be earlier than From Date.";
      }

      return errors;
    };

    if (todaySalesOrderData?.fromDate || todaySalesOrderData?.toDate) {
      const { fromDateError, toDateError } = validateDates(
        todaySalesOrderData.fromDate,
        todaySalesOrderData.toDate,
      );

      setFromDateError(fromDateError);
      setToDateError(toDateError);
    } else {
      setFromDateError(null);
      setToDateError(null);
    }
  }, [todaySalesOrderData?.fromDate, todaySalesOrderData?.toDate]);

  const fetchtodaySalesOrder = async () => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, todaySalesOrder, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize
      });

      if (res?.todaySalesOrders?.success) {
        setData(res?.todaySalesOrders?.data);
        setDataCount({
          pageCount: res?.todaySalesOrders?.totalPages,
          itemCount: res?.todaySalesOrders?.totalCount
        })
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = async (orderId) => {
    const { value: status } = await Swal.fire({
      title: "Change Status",
      input: "select",
      inputOptions: {
        Approved: "Approve",
        Rejected: "Reject",
      },
      inputPlaceholder: "Select a status",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "You need to select a status!";
        }
      },
    });

    if (status) {
      setCirleLoading(true);
      try {
        const res = await request(BASEURL, updateSalesOrder, {
          input: {
            salesOrderId: Number(orderId),
            status: status,
          },
        });

        const success = res?.updateSalesOrder?.success;

        if (success) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: "Status Change Successfully",
            showConfirmButton: true,
          }).then(() => {
            if (value === 0) {
              fetchtodaySalesOrder();
            } else if (value === 1) {
              fetchPastPendingSalesOrder();
            } else {
              fetchPastApprovedSalesOrder()
            }
          });
        }
      } catch (err) {
      } finally {
        setCirleLoading(false);
      }
    }
  };

  const handleDownloadPdf = async (data) => {
    setCirleLoading(true);

    try {

      const res = await request(BASEURL, generateSalesorderPdf, {
        id: Number(data?.id),
      });

      const success = res?.generateSalesorderPdf?.success;
      const message = res?.generateSalesorderPdf?.message;
      const pdfUrl = `${PDFURL}${res?.generateSalesorderPdf?.pdfUrl}`;

      if (success && pdfUrl) {
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download",
          `${data?.soNumber || "Sales_Order"}_${data?.customer?.customerName || ""}.pdf`
        );

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error downloading PDF:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {value === 0 ? "Today's Sales Order List" : value === 1 ? "Past Pending Sales Order List" : "Past Approved Sales Order List"}
                  </MaterialTypography>
                </Stack>

                <RoleAccess
                  modelName="Sales Order Screen"
                  component="CreateSalesOrder"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      navigate("/sales-order/add-sales-order", {
                        state: { type: "add" },
                      })
                    }
                  >
                    Sales Order
                  </MaterialButton>
                </RoleAccess>
              </Stack>
              <Box sx={{ marginTop: "5px" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Box sx={{ bgcolor: "background.paper" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#2a9941",
                          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.66)",
                        },
                      }}
                      centered
                      sx={{
                        "& .MuiTab-root": {
                          fontSize: "15px",
                          minHeight: "40px",
                          textTransform: "none",
                          padding: "6px 12px",
                        },
                      }}
                    >
                      <Tab
                        disabled={isLoading}
                        label="Today Sales Order List"
                      />
                      <Tab
                        disabled={isLoading}
                        label="Past Pending Sales Order List"
                      />
                      <Tab
                        disabled={isLoading}
                        label="Past Approved Sales Order List"
                      />
                    </Tabs>
                  </Box>
                  {value !== 0 && (
                    <Box sx={{ flex: 1 }}>
                      <Grid container spacing={2} p={1}>
                        <Grid size={{ xs: 6, sm: 5 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              From Date
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            type="date"
                            size="small"
                            name="fromDate"
                            value={todaySalesOrderData?.fromDate}
                            onChange={(e) =>
                              dispatch({
                                value: e?.target?.value,
                                name: "fromDate",
                              })
                            }
                          />
                          {fromDateError && (
                            <MaterialTypography
                              color="error"
                              variant="caption"
                              display="block"
                              mt={1}
                            >
                              {fromDateError}
                            </MaterialTypography>
                          )}
                        </Grid>
                        <Grid size={{ xs: 6, sm: 5 }}>
                          <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                            >
                              To Date
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            type="date"
                            size="small"
                            name="toDate"
                            value={todaySalesOrderData?.toDate}
                            onChange={(e) =>
                              dispatch({
                                value: e?.target?.value,
                                name: "toDate",
                              })
                            }
                          />
                          {toDateError && (
                            <MaterialTypography
                              color="error"
                              variant="caption"
                              display="block"
                              mt={1}
                            >
                              {toDateError}
                            </MaterialTypography>
                          )}
                        </Grid>
                        <Grid size={{ xs: 6, sm: 2 }}>
                          <IconButton
                            onClick={resetFilters}
                            aria-label="Reset Filters"
                            color="primary"
                            sx={{ mt: 2 }}
                          >
                            <RefreshIcon fontSize="large" />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {/* <RoleAccess
                    modelName="Today Product Screen"
                    component="ExportTodayProduct"
                  >
                    {data?.length > 0 &&
                      (value == 0 ||
                        (value == 1 &&
                          todaySalesOrderData?.fromDate &&
                          todaySalesOrderData?.toDate)) && (
                        <button
                          className="container-btn-file"
                          onClick={handleDownload}
                          style={{
                            height: "38px",
                            marginLeft: "0",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          <svg
                            fill="#fff"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 50 50"
                          >
                            <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                          </svg>
                          Export File
                        </button>
                      )}
                  </RoleAccess> */}

                  {/* <RoleAccess
                    modelName="Today Product Screen"
                    component="UploadTodayProduct"
                  >
                    {value == 0 && (
                      <label
                        className="container-btn-file"
                        style={{
                          height: "38px",
                          marginLeft: "0",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => handleUploadClick()} // show the modal
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 50 50"
                        >
                          <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                        </svg>
                        Upload File
                      </label>
                    )}
                  </RoleAccess> */}
                </Stack>
              </Box>
            </>
          }
        />
        {!isLoading && (
          <TableComponents
            rows={salesOrderListTable?.rows}
            columns={salesOrderListTable?.columns}
            pagination={pagination}
            setPagination={setPagination}
            pageCount={dataCount.pageCount}
            recordCount={dataCount.itemCount}
            isLoading={isLoading}
            isSearch={false}
          />
          // <MaterialDataGrid
          //   // customHeight={550}
          //   rows={salesOrderListTable.rows}
          //   columns={salesOrderListTable.columns}
          //   // checkboxSelection={false}
          //   isSelectable={false}
          //   // onRowClick={onCustomerListClick}
          //   //   loading={pageState.loading}
          //   localeText={{
          //     noRowsLabel: (
          //       <Stack
          //         direction="column"
          //         alignItems="center"
          //         justifyContent="center"
          //         spacing={1}
          //       >
          //         <MaterialTypography
          //           variant="body2"
          //           fontWeight="medium"
          //           color="text"
          //         >
          //           No Sales Order found
          //         </MaterialTypography>
          //         <MaterialTypography variant="caption" color="text">
          //           You have not yet add any sales order details. Click on the
          //           "Add sales order" button to start adding sales order
          //           details.
          //         </MaterialTypography>
          //       </Stack>
          //     ),
          //   }}
          // />
        )}
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default SalesOrderList;
